import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { NexusAnalyticsProvider } from './components/tracker-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <NexusAnalyticsProvider 
            apiUrl="https://nexus-api.jiricech2059.com/api/analytics/track"
            siteId="cchi-kung"
        >
            <>
                {/* <SnowfallGlobal /> */}
                <App />
            </>
        </NexusAnalyticsProvider>
    </React.StrictMode>
);
